import { render } from "./KpisWebeasy.vue?vue&type=template&id=36c23c48&scoped=true"
import script from "./KpisWebeasy.vue?vue&type=script&lang=js"
export * from "./KpisWebeasy.vue?vue&type=script&lang=js"

import "./KpisWebeasy.vue?vue&type=style&index=0&id=36c23c48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c23c48"]])

export default __exports__